import './style.css';
import { LuxRelayGame } from './game/game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
const uiRoot = document.querySelector<HTMLElement>('#ui-root');
const liveStatus = document.querySelector<HTMLElement>('#live-status');

if (!canvas || !uiRoot || !liveStatus) throw new Error('LUX RELAY boot elements are missing');

const game = new LuxRelayGame(canvas, uiRoot, liveStatus);

window.addEventListener('beforeunload', () => game.destroy(), { once: true });

